import { GET_REPORT_TITLES, GET_SSWP_CONFIGS, GET_HSQE_CONFIGS } from "./types";
import firebase from "firebase/app";
export const getReportTitles = () => {
    return dispatch => {
        dispatch({ type: GET_REPORT_TITLES.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/report_titles`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_REPORT_TITLES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_REPORT_TITLES.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_REPORT_TITLES.FAIL });
        }
    };
};
export const getSSWPConfigs = () => {
    return dispatch => {
        dispatch({ type: GET_SSWP_CONFIGS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/master_sswp_v2_config`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_SSWP_CONFIGS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_SSWP_CONFIGS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_SSWP_CONFIGS.FAIL });
        }
    };
};

export const getHSQEConfigs = () => {
    return dispatch => {
        dispatch({ type: GET_HSQE_CONFIGS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/report_templates`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_HSQE_CONFIGS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_HSQE_CONFIGS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_HSQE_CONFIGS.FAIL });
        }
    };
};
